import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'ui',
  initialState: {
    showLeaderboard: false,
    isLandscape: false,
  },
  reducers: {
    setShowLeaderboard: (state, action) => {
      state.showLeaderboard = action.payload;
    },
    setIsLandscape: (state, action) => {
      state.isLandscape = action.payload;
    },
    setState: (state, action) => {
      // console.log('Action', action.payload)
      return {
        ...state,
        ...action.payload,
      }
    }
  },
});

export const { setShowLeaderboard, setIsLandscape, setState } = slice.actions;

export default slice.reducer;
